import EmblaCarousel, { EmblaProps } from './embla/EmblaCarousel';

const ImageCarousel: React.FC<EmblaProps> = async (props) => {
  const newProps = { ...props };

  return <EmblaCarousel {...newProps} options={{ loop: true }}></EmblaCarousel>;
};

export default ImageCarousel;
